import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { selectBibEntities } from '../EntitiesSelector';

const getManifestationIds = state => state.getIn(['catalogBibs', 'manifestations', 'ids'], Immutable.List());
const getManifestations = state => state.getIn(['catalogBibs', 'manifestations'], Immutable.Map());
const getEditionIds = state => state.getIn(['catalogBibs', 'catalogBib', 'editions'], Immutable.List());

export const selectManifestationsForCurrentBib = createSelector(
  [getManifestationIds, selectBibEntities],
  (metadataIds, bibEntities) => metadataIds.map(metadataId => bibEntities.get(metadataId))
);

export const selectManifestationsSummary = createSelector([getManifestations], manifestations => manifestations);

export const selectEditionsForCurrentBib = createSelector(
  [getEditionIds, selectBibEntities],
  (editionIds, bibEntities) => editionIds.map(editionId => bibEntities.get(editionId))
);

export default {
  selectManifestationsSummary,
  selectManifestationsForCurrentBib,
  selectEditionsForCurrentBib
};
